import * as common from './common';
import * as modal from './module/modal';
import * as create_album from './module/create_album';
import * as edit_title from './module/edit_title';
import * as edit_option from './module/edit_option';

$(function () {

    // アルバム追加ボタン
    $(".album_box_add").on("click", function () {
        $('#createAlbum_modal').fadeIn();
        modal.stopScroll();
    });

    // アルバムメニューボタン
    $(".album_menu_btn").on("click", function (e) {
        e.stopPropagation();

        const album_menu = $(this).find('.album_menu');
        if (album_menu.hasClass('active')) {
            album_menu.removeClass('active')
        } else {
            $('.active').removeClass('active');
            album_menu.addClass('active');
        }
    });

    // タイトル変更ボタン
    $(".album_title_edit").on("click", function (e) {
        // タイトルを取得してフォームに挿入
        document.getElementById("title_new").value = $(this).closest('.album_box_out').find('.album_title').text();
        document.getElementById("album_uuid_new").value = this.getAttribute('uuid');

        $('.active').removeClass('active');
        $('#editTitle_modal').fadeIn();
        e.stopPropagation();

        modal.stopScroll();
    });

    // オプション
    $(".album_set").on("click", function () {
        edit_option.getOption(this.getAttribute('uuid'));
        $('#editOption_modal').fadeIn();
        modal.stopScroll();
    });
    

    // 削除ボタン
    $(".album_del").on("click", function () {
        Swal.fire({
            title: '本当に削除しますか？',
            text: "削除すると元に戻せません。",
            showCancelButton: true,
            confirmButtonText: '削除',
            cancelButtonText: 'キャンセル',
        }).then((result) => {
            if (result.isConfirmed) {
                delAlbum(this.getAttribute('uuid'));
            }
        });
    });

    // 画面クリックでメニュー閉じる
    $(document).on("click", function () {
        $('.active').removeClass('active');
    });
    
    // ストレージ情報取得
    getStorageInfo();
});


//　ディスク情報取得
function getStorageInfo() {
    $.ajax({
        type: 'GET',
        url: mypath + 'storageinfo',
        data: {},
        dataType: 'json',
        scriptCharset: 'utf-8',
        cache: false
    })
        .then(
            function (res) {

                if (res.flag) {

                    // ストレージ情報　挿入
                    let storageInfoText = '';
                    if (res.diskLimit >= (1024 * 1024 * 1024)) {
                        storageInfoText = `ストレージ：${Math.round(res.storageUsage / 1073741824 * 10) / 10} / ${Math.round(res.diskLimit / 1073741824)} GB`;
                    } else {
                        storageInfoText = `ストレージ：${Math.round(res.storageUsage / 1048576 * 10) / 10} / ${Math.round(res.diskLimit / 1048576)} MB`;
                    }
                    storageInfo.insertAdjacentHTML('beforeend', storageInfoText);

                    let barLength = (res.storageUsage / res.diskLimit) * 100;
                    if (barLength > 100) barLength = 100;
                    if (barLength != 0 && barLength < 5) barLength = 5;

                    $('.album_storage_bar').css({
                        'width': barLength + '%'
                    });

                    if (res.storageUsage >= res.diskLimit) {
                        $('.album_storage_bar_out').css({
                            'border-color': '#c51f1a'
                        });
                        $('.album_storage_bar').css({
                            'background-color': '#c51f1a'
                        });
                    }


                    // アルバム追加ボタンを有効にする
                    if ($('.album_box').length <= res.albumLimit || res.albumLimit == -1) {
                        $('.album_box_add').css({
                            'pointer-events': 'auto'
                        });
                    }
                } else {
                    storageInfo.insertAdjacentHTML('beforeend', 'ストレージエラー');
                }

            },
            function (XMLHttpRequest, textStatus, errorThrown) {
                storageInfo.insertAdjacentHTML('beforeend', 'ストレージエラー');
            });
}

//　アルバム削除
function delAlbum(uuid) {
    $.ajax({
        type: 'POST',
        url: mypath + 'home/delete',
        data: {
            'uuid': uuid
        },
        dataType: 'json',
        scriptCharset: 'utf-8',
        cache: false
    })
        .then(
            function (res) {

                if (res['flag']) {

                    // リロード
                    location.reload();

                } else {
                    Swal.fire({
                        title: 'エラー',
                        text: '',
                        confirmButtonText: 'OK'
                    });
                }
            },
            function (XMLHttpRequest, textStatus, errorThrown) {
                // リロード
                location.reload();
            });
}